import { useLocation } from 'react-router-dom';
import { getAuthCookies } from '@webmotors/consumer-shared-auth';
import { ENV } from '@/app/config';
import type { TUseLayoutReturn } from './layout.types';

/**
 * Encapsulates auth-cookie reading for the Layout component.
 * Header receives `authToken` (JWT Cognito) for self-resolving mode:
 * it decodes the JWT internally for user info and opens a
 * WebSocket one-shot to fetch unread chat count automatically.
 *
 * Footer: ativa Côpi (Droz), cookie consent e baseUrl do portal via ENV.
 */
const useLayout = (): TUseLayoutReturn => {
	const { pathname } = useLocation();
	const { idToken } = getAuthCookies();
	const authToken = idToken ?? undefined;
	const portalBaseUrl = ENV.URL_PORTAL;
	const isCheckoutRoute = pathname.includes('/pagamento');

	return {
		authToken,
		portalBaseUrl,
		isCheckoutRoute,
		footerConfig: {
			baseUrl: portalBaseUrl,
			enableCopiHelp: true,
			enableCookieManagement: true,
			showMembershipTerm: true,
			copiAuthToken: authToken
		}
	};
};

export { useLayout };
